import { renderTemplate, TemplateContext } from '@notification/utils'
import { Flex, Modal, Tooltip, Typography } from 'antd'
import { Eye } from 'iconsax-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useStyles } from './styles'

type Props = {
  value?: string | null
  context?: TemplateContext
}

export const NotificationTemplatePreview = ({ value, context }: Props) => {
  const { styles } = useStyles()
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const toggleModal = () => setIsOpen((open) => !open)

  return (
    <Flex onClick={(e) => e.stopPropagation()}>
      <Tooltip title={t('preview_notification')}>
        <Typography.Link className={styles.link} onClick={toggleModal}>
          <Eye size="16" />
        </Typography.Link>
      </Tooltip>

      <Modal
        width={800}
        open={isOpen}
        title={t('preview_notification')}
        cancelButtonProps={{ hidden: true }}
        onOk={toggleModal}
        onCancel={toggleModal}
      >
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{
            __html: renderTemplate(value, context)
          }}
        />
      </Modal>
    </Flex>
  )
}
